// 실명 마스킹(goals.md 원칙 2). AI로 보내기 전에 이름을 [P1] 토큰으로 바꾸고, 결과를 받은 뒤 되돌린다.
// 서버/모델은 실제 이름·회사명을 보지 못한다.
export type MaskMap = Record<string, string>

export interface Maskable { name: string; aliases?: string[] }

/** people[0]을 [P1]로 둔다(보통 받는 사람). 긴 이름부터 치환해 부분 겹침을 막는다. */
export function buildMask(people: Maskable[]): { map: MaskMap; apply: (text: string) => string } {
  const map: MaskMap = {}
  const entries: { needle: string; token: string }[] = []
  people.forEach((p, i) => {
    const token = `[P${i + 1}]`
    map[token] = p.name
    for (const n of [p.name, ...(p.aliases || [])]) if (n && n.trim()) entries.push({ needle: n.trim(), token })
  })
  entries.sort((a, b) => b.needle.length - a.needle.length)
  const apply = (text: string) => {
    let s = text
    for (const e of entries) s = s.split(e.needle).join(e.token)
    return s
  }
  return { map, apply }
}

export function unmask(text: string, map: MaskMap): string {
  let s = text
  for (const [token, name] of Object.entries(map)) s = s.split(token).join(name)
  return s
}
